import { getCookie } from '@/assets/js/tool'

//当前登录账号的用户信息
export default {
  //开启命名空间
  namespaced: true,
  //state状态
  state: {
    //用户信息
    userInfo: {
      // accessToken:'AI51WRq6Z9xrufmoSxz7mHc6lMzYSb9dnzbDxB9C89F8TEyq3ZH9if2hFJ6c3nWLXNl0tZw40oIw8cfZYn90UwaO5zlUmtgVigpnDvGQ0d2IjOSQQWtxxshk74EJw4AS',
      accessToken:''
    },
  },
  //mutations处理同步操作
  
  mutations: {
    UPDATEINFO(state, payload) {
      if (payload) {
        state.userInfo = Object.assign(state.userInfo, payload)
      }
    },

    //读取cookie
    UPDATEUSERINFO(state) {
      let userInfo = getCookie('courseInfo')
      if (userInfo && (userInfo = JSON.parse(userInfo))) {
        state.userInfo = userInfo
      }
    },

    //退出登录
    DELETETOKEN(state) {
      state.userInfo.accessToken = ""
    },

    //退出登录
    LOGOUT(state) {
      state.userInfo = {}
    },
  },
  //actions 主要是异步操作
  actions: {},
}
